import React, { useEffect, useState } from 'react'
import { Upload } from 'antd'
import type { GetProp, UploadFile, UploadProps } from 'antd'
import { RcFile } from 'antd/es/upload'
import Compressor from 'compressorjs'
import { v4 as uuidv4 } from 'uuid'
import { uploadFile, deleteFile } from '../../Utility/storage/storage'

type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0]

const UploadImage = ({ images, fileType, imageType, onImageUpload }: any) => {
  const [fileList, setFileList] = useState<UploadFile[]>(images)

  useEffect(() => {
    setFileList(images)
  }, [images])

  const onChange: UploadProps['onChange'] = ({ fileList: newFileList }) => {
    setFileList(newFileList)
  }

  const onPreview = async (file: UploadFile) => {
    let src = file.url as string
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader()
        reader.readAsDataURL(file.originFileObj as FileType)
        reader.onload = () => resolve(reader.result as string)
      })
    }
    const image = new Image()
    image.src = src
    const imgWindow = window.open(src)
    imgWindow?.document.write(image.outerHTML)
  }

  const onRemove = async (file: UploadFile) => {
    try {
      await deleteFile(`${fileType}/${file.name}`)
      const imageToBeRemovedIndex = images.findIndex(
        (image: any) => image.name === file.name
      )
      images.splice(imageToBeRemovedIndex, 1)
      setFileList([...images])
      onImageUpload([...images])
    } catch (error) {
      console.log('Remove error:', error)
    }
  }

  const uploadImage = async (file: RcFile) => {
    return new Promise<string>((resolve, reject) => {
      new Compressor(file, {
        quality: 0.4,
        convertTypes: ['image/png', 'image/jpg', 'image/jpeg', 'image/webp'],
        convertSize: 500,
        async success(result: File) {
          try {
            const url = await uploadFile(`${fileType}/${file.name}`, result)
            const fileObject = {
              uid: uuidv4(),
              name: file.name,
              url,
            }
            const updated = [...images, fileObject]
            onImageUpload(updated)
            resolve(url)
          } catch (err: any) {
            console.log('Upload error:', err)
            reject(err)
          }
        },
        error(err) {
          console.log(err.message)
          reject(err)
        },
      })
    })
  }

  const customRequest = async (options: any) => {
    const { file, onSuccess, onError } = options
    try {
      await uploadImage(file as RcFile)
      onSuccess('ok')
    } catch (err) {
      onError(err)
    }
  }

  if (imageType === 'logo') {
    return (
      <Upload
        customRequest={customRequest}
        listType='picture-circle'
        fileList={fileList}
        onChange={onChange}
        onPreview={onPreview}
        onRemove={onRemove}
      >
        {fileList.length < 1 && '+ Upload'}
      </Upload>
    )
  }

  return (
    <Upload
      customRequest={customRequest}
      listType='picture-circle'
      fileList={fileList}
      onChange={onChange}
      onPreview={onPreview}
      onRemove={onRemove}
    >
      {fileList.length < 5 && '+ Upload'}
    </Upload>
  )
}

export default UploadImage
